<div class="betslip-over-ask-pick betslip-over-ask-pick--betbuilder">
    <div class="betslip-over-ask-pick__line-0">
        <div class="title-container">
            <div class="title-header">
                <span class="header">{{ messages.betBuilderMarketName }}</span>
                <span class="title-header-seperator"></span>
                <span class="legs">{{ pick.getLegCount() }} {{ legsText }}</span>
            </div>
            <div class="event-name">
                <span class="name">{{ pick.eventName.name }}</span>
                <span class="event-name-seperator"></span>
                <span class="date">{{ pick.eventDate | date: 'shortDate' }} {{ pick.eventDate | date: 'shortTime' }} </span>
            </div>
        </div>
        @for (leg of pick.getLegs(); track leg) {
            <div class="over-ask-betbuilder-pick-items">
                <div class="over-ask-betbuilder-pick-item">
                    <div class="circle-overlay"><div class="theme-radio-off"></div></div>
                    <div class="option-market-list">{{ leg }}</div>
                </div>
            </div>
        }
    </div>
    <div class="betslip-over-ask-pick__changes">
        <ng-content select="[price-changes]"></ng-content>
    </div>
    <div class="betslip-over-ask-pick__remove-container">
        <ng-content select="[remove-button]"></ng-content>
    </div>
    <div class="betslip-over-ask-pick__winnings">
        <ng-content select="[multi-single-possible-winnings]"></ng-content>
    </div>
</div>
